import { Link } from 'wouter'
import {
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    ListSubheader,
    Tooltip,
} from '@mui/material'
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate'
import BadgeIcon from '@mui/icons-material/Badge'
import useSession from '@hooks/useSession'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import DomainAddIcon from '@mui/icons-material/DomainAdd'
import NotificationsPausedIcon from '@mui/icons-material/NotificationsPaused'
import PaymentsIcon from '@mui/icons-material/Payments'
import PeopleIcon from '@mui/icons-material/People'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import PersonSearchIcon from '@mui/icons-material/PersonSearch'
import PollIcon from '@mui/icons-material/Poll'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import TableViewIcon from '@mui/icons-material/TableView'
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation'
import VideocamIcon from '@mui/icons-material/Videocam'
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline'
import CallMergeIcon from '@mui/icons-material/CallMerge'
import ContactPageIcon from '@mui/icons-material/ContactPage'
import LocalActivityIcon from '@mui/icons-material/LocalActivity'
import VpnLockIcon from '@mui/icons-material/VpnLock'
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch'
import RuleIcon from '@mui/icons-material/Rule'
import BlockIcon from '@mui/icons-material/Block'

const DashboardNavigation = () => {
    const session = useSession()
    const canManageStaffAccess = session?.self.role === 'superadmin'

    return (
        <nav>
            <List dense disablePadding>
                <ListSubheader>Overview</ListSubheader>
                {/* search users */}
                <ListItem disablePadding>
                    <ListItemButton href="/all-users" LinkComponent={Link}>
                        <ListItemIcon>
                            <PeopleIcon />
                        </ListItemIcon>
                        <ListItemText primary="All Users" />
                    </ListItemButton>
                </ListItem>
                {/* Right now this is undesired but leaving it here in case we want to bring back a direct link on review */}
                {/* <ListItem disablePadding>
                    <ListItemButton href="/user-deepdive" LinkComponent={Link}>
                        <ListItemIcon>
                            <PersonSearchIcon />
                        </ListItemIcon>
                        <ListItemText primary="User Deep Dive" />
                    </ListItemButton>
                </ListItem> */}
                <ListItem disablePadding>
                    <ListItemButton href="/Organizations" LinkComponent={Link}>
                        <ListItemIcon>
                            <PersonSearchIcon />
                        </ListItemIcon>
                        <ListItemText primary="Organizations" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        href="/org-collections"
                        LinkComponent={Link}
                    >
                        <ListItemIcon>
                            <PersonSearchIcon />
                        </ListItemIcon>
                        <ListItemText primary="Org Collections" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton href="/sessions" LinkComponent={Link}>
                        <ListItemIcon>
                            <ViewTimelineIcon />
                        </ListItemIcon>
                        <ListItemText primary="Sessions" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton href="/denied-orgs" LinkComponent={Link}>
                        <ListItemIcon>
                            <BlockIcon />
                        </ListItemIcon>
                        <ListItemText primary="Denied Organizations" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton href="/podiums" LinkComponent={Link}>
                        <ListItemIcon>
                            <VideocamIcon />
                        </ListItemIcon>
                        <ListItemText primary="Podiums" />
                    </ListItemButton>
                </ListItem>
                <ListSubheader>Search</ListSubheader>
                {/* search users */}
                {/* <ListItem disablePadding>
                    <ListItemButton href="/users" LinkComponent={Link}>
                        <ListItemIcon>
                            <PeopleIcon />
                        </ListItemIcon>
                        <ListItemText primary="Users" />
                    </ListItemButton>
                </ListItem> */}
                {/* search orders */}
                {/* <ListItem disablePadding>
                    <ListItemButton disabled>
                        <ListItemIcon>
                            <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Orders" />
                    </ListItemButton>
                </ListItem> */}
                {/* search nte invoices — hidden, not deleted.
                    The two invoice downloads were the reason anyone opened
                    this, and they have gone. What remains is a lookup from a
                    school or invoice number to a Xero invoice id, which is
                    worth keeping until someone confirms nobody wants it. The
                    page and its route are untouched, so /nte-invoice-search
                    still works for anyone holding the link. Restoring it also
                    needs the ReceiptIcon import back.
                <ListItem disablePadding>
                    <ListItemButton
                        href="/nte-invoice-search"
                        LinkComponent={Link}
                    >
                        <ListItemIcon>
                            <ReceiptIcon />
                        </ListItemIcon>
                        <ListItemText primary="NTE Invoices" />
                    </ListItemButton>
                </ListItem> */}
                {/* reports */}
                <ListSubheader>Reports</ListSubheader>
                <ListItem disablePadding>
                    <ListItemButton
                        href="/overdue-orders-report"
                        LinkComponent={Link}
                    >
                        <ListItemIcon>
                            <AssignmentLateIcon />
                        </ListItemIcon>
                        <ListItemText primary="Overdue Orders" />
                    </ListItemButton>
                </ListItem>
                {/* completed orders */}
                <ListItem disablePadding>
                    <ListItemButton
                        href="/completed-orders-report"
                        LinkComponent={Link}
                    >
                        <ListItemIcon>
                            <AssignmentTurnedInIcon />
                        </ListItemIcon>
                        <ListItemText primary="Completed Orders" />
                    </ListItemButton>
                </ListItem>
                {/* billable hours */}
                <ListItem disablePadding>
                    <ListItemButton
                        href="/billable-hours-report"
                        LinkComponent={Link}
                    >
                        <ListItemIcon>
                            <PaymentsIcon />
                        </ListItemIcon>
                        <ListItemText primary="Billable Hours" />
                    </ListItemButton>
                </ListItem>
                {/* subcontracter hours */}
                <ListItem disablePadding>
                    <ListItemButton
                        href="/subcontractor-hours-report"
                        LinkComponent={Link}
                    >
                        <ListItemIcon>
                            <PaymentsIcon />
                        </ListItemIcon>
                        <ListItemText primary="Subcontractor Hours" />
                    </ListItemButton>
                </ListItem>
                {/* Usage Report */}
                <ListItem disablePadding>
                    <ListItemButton href="/usage-report" LinkComponent={Link}>
                        <ListItemIcon>
                            <TableViewIcon />
                        </ListItemIcon>
                        <ListItemText primary="Usage" />
                    </ListItemButton>
                </ListItem>
                {/* Inactive Users Report */}
                <ListItem disablePadding>
                    <ListItemButton
                        href="/inactive-users-report"
                        LinkComponent={Link}
                    >
                        <ListItemIcon>
                            <NotificationsPausedIcon />
                        </ListItemIcon>
                        <ListItemText primary="Inactive Users" />
                    </ListItemButton>
                </ListItem>
                {/* Eligible Users Report */}
                <ListItem disablePadding>
                    <ListItemButton
                        href="/eligible-users-report"
                        LinkComponent={Link}
                    >
                        <ListItemIcon>
                            <PollIcon />
                        </ListItemIcon>
                        <ListItemText primary="Eligible Users" />
                    </ListItemButton>
                </ListItem>
                {/* Actions */}
                <ListSubheader>Actions</ListSubheader>
                <ListItem disablePadding>
                    <ListItemButton href="/review-orgs">
                        <ListItemIcon>
                            <RuleIcon />
                        </ListItemIcon>
                        <ListItemText primary="Review Org Applications" />
                    </ListItemButton>
                </ListItem>
                {/* Add New Admin To Org */}
                <ListItem disablePadding>
                    <ListItemButton
                        href="/add-new-admin-to-org"
                        LinkComponent={Link}
                    >
                        <ListItemIcon>
                            <PersonAddIcon />
                        </ListItemIcon>
                        <ListItemText primary="Add New Admin To Org" />
                    </ListItemButton>
                </ListItem>
                {/* Tranfer user */}
                <ListItem disablePadding>
                    <ListItemButton href="/transfer-user" LinkComponent={Link}>
                        <ListItemIcon>
                            <TransferWithinAStationIcon />
                        </ListItemIcon>
                        <ListItemText primary="Transfer a User" />
                    </ListItemButton>
                </ListItem>
                {/*Send invoice*/}
                <ListItem disablePadding>
                    <ListItemButton href="/send-invoice" LinkComponent={Link}>
                        <ListItemIcon>
                            <ReceiptLongIcon />
                        </ListItemIcon>
                        <ListItemText primary="Send Invoice" />
                    </ListItemButton>
                </ListItem>
                {/*Create new org*/}
                <ListItem disablePadding>
                    <ListItemButton href="/create-new-org" LinkComponent={Link}>
                        <ListItemIcon>
                            <DomainAddIcon />
                        </ListItemIcon>
                        <ListItemText primary="Create New Org" />
                    </ListItemButton>
                </ListItem>
                {/* Merge Accounts */}
                <ListItem disablePadding>
                    <ListItemButton href="/merge-accounts" LinkComponent={Link}>
                        <ListItemIcon>
                            <CallMergeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Merge Accounts" />
                    </ListItemButton>
                </ListItem>
                {/* Merge Accounts */}
                <ListItem disablePadding>
                    <ListItemButton
                        href="/create-uk-license"
                        LinkComponent={Link}
                    >
                        <ListItemIcon>
                            <LocalActivityIcon />
                        </ListItemIcon>
                        <ListItemText primary="Create UK License" />
                    </ListItemButton>
                </ListItem>
                {/* Manage SSO connections */}
                <ListItem disablePadding>
                    <ListItemButton
                        href="/manage-sso-connections"
                        LinkComponent={Link}
                    >
                        <ListItemIcon>
                            <VpnLockIcon />
                        </ListItemIcon>
                        <ListItemText primary="Manage SSO Connections" />
                    </ListItemButton>
                </ListItem>
                {/* Staff access — superadmins only. Shown to everyone but
                    disabled for the rest, so the page is discoverable and
                    people know who to ask rather than wondering whether it
                    exists. Presentation only: Habitat Admin refuses the
                    requests regardless of what this renders. The href is
                    dropped when disabled so the anchor can't be followed
                    by keyboard or context menu. */}
                <ListItem disablePadding>
                    <Tooltip
                        title={
                            canManageStaffAccess
                                ? ''
                                : 'Superadmins only — ask an engineer if you need access changed'
                        }
                        placement="right"
                    >
                        {/* Tooltips need a child that can receive events,
                            and a disabled button cannot. */}
                        <span style={{ width: '100%' }}>
                            {canManageStaffAccess ? (
                                <ListItemButton
                                    href="/staff-access"
                                    LinkComponent={Link}
                                >
                                    <ListItemIcon>
                                        <BadgeIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Staff Access" />
                                </ListItemButton>
                            ) : (
                                <ListItemButton disabled>
                                    <ListItemIcon>
                                        <BadgeIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Staff Access" />
                                </ListItemButton>
                            )}
                        </span>
                    </Tooltip>
                </ListItem>
                {/* Onboard a new SSO tenant */}
                <ListItem disablePadding>
                    <ListItemButton
                        href="/onboard-sso-tenant"
                        LinkComponent={Link}
                    >
                        <ListItemIcon>
                            <RocketLaunchIcon />
                        </ListItemIcon>
                        <ListItemText primary="Onboard SSO Tenant" />
                    </ListItemButton>
                </ListItem>
                {/* Assign orgs to Xero contacts */}
                <ListItem disablePadding>
                    <ListItemButton
                        href="/org-xero-contacts"
                        LinkComponent={Link}
                    >
                        <ListItemIcon>
                            <ContactPageIcon />
                        </ListItemIcon>
                        <ListItemText primary="Org Xero Contacts" />
                    </ListItemButton>
                </ListItem>
            </List>
        </nav>
    )
}

export default DashboardNavigation
